export default "__VITE_ASSET__C5k9emIu__"